import React from 'react';
import styled from 'styled-components';
import {
  LandingCheckBox,
  LandingLaptop,
  LandingMessage,
  LandingRocket,
  LandingSpeaker,
} from '../../../Common/SvgIcon/CommonSvgIcons';
import { Helmet } from 'react-helmet-async';

const sizes = {
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  desktop: '1800px',
};

export const device = {
  tablet: `(max-width: ${sizes.tablet})`,
  desktop: `(min-width: ${sizes.desktop})`,
};

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #e6f0f0;
  padding-bottom: 120px;
  @media only screen and ${device.tablet} {
    padding-bottom: 60px;
  }
`;

const CardContainer = styled.div`
  width: 1140px;
  display: flex;
  margin-top: 60px;
  justify-content: space-between;
  @media only screen and ${device.tablet} {
    flex-direction: column;
    align-items: center;
    max-width: 345px;
    margin-top: 30px;
  }
`;

const Title = styled.div`
  margin-top: 60px;
  font-family: Inter;
  font-weight: 600;
  font-size: 32px;

  text-align: center;
  vertical-align: middle;
  background-image: linear-gradient(90deg, #063257 0%, #006867 100%);
  color: transparent;
  background-clip: text;
  @media only screen and ${device.tablet} {
    font-size: 24px;
    margin-top: 0px;
  }
`;
const IndividualCard = styled.div`
  width: 205px;
  justify-content: space-between;
  border-radius: 20px;
  padding: 30px;
  border-width: 1.5px;
  background: linear-gradient(170.93deg, #b0d0d0 3.11%, #e6f0f0 96.89%);
  border: 1.5px solid;

  border-image-source: linear-gradient(
    164.15deg,
    #f2f2f2 0.27%,
    #8abab9 99.73%
  );
  @media only screen and ${device.tablet} {
    width: 285px;
    margin-top: 15px;
  }
`;
const CardTitle = styled.div`
  font-family: Inter;
  font-weight: 700;
  font-size: 22px;

  color: #0c3f89;
  text-align: left;
  @media only screen and ${device.tablet} {
    font-size: 24px;
  }
`;

const OptionsContainer = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 10px;
  @media only screen and ${device.tablet} {
    margin-top: 20px;
  }
`;

const OptionsText = styled.div`
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;

  width: 198px;
  text-wrap: wrap;
  text-align: left;
  @media only screen and ${device.tablet} {
    width: 285px;
    font-size: 16px;
  }
`;
const ImageContainer = styled.div`
  padding-top: 24px;
  padding-right: 20px;
  padding-bottom: 24px;
  padding-left: 20px;
  gap: 10px;
  border-radius: 10px;
  background: linear-gradient(108.56deg, #063257 1.05%, #2a876c 110.19%);
`;
const impactDataArray = [
  {
    title: 'Marketing, Branding & PR',
    options: [
      'Monitor real-time brand perception  ',
      'Identify risks & reputation threats  ',
      'Optimize campaign resonance based on audience insights ',
    ],
    image: LandingSpeaker,
  },
  {
    title: 'Consumer Insights & Research ',
    options: [
      'Decode emotional drivers behind trends & consumer behaviour ',
      'Predict consumer behavior shifts  ',
      'Identify whitespace opportunities',
    ],
    image: LandingMessage,
  },
  {
    title: 'Product & Service Innovation ',
    options: [
      'Identify unmet consumer needs',
      'Validate product-market fit',
      'Spot innovation gaps early',
    ],
    image: LandingRocket,
  },
  {
    title: 'Corporate Strategy ',
    options: [
      'Identify emerging opportunities',
      'Competitive intelligence & market shifts',
      'Anticipate industry disruptions',
      'Risk mitigation & scenario planning',
    ],
    image: LandingLaptop,
  },
];
const MapContainer = styled.div`
  height: 180px;
  margin-top: 30px;
  @media only screen and ${device.tablet} {
    height: 210px;
  }
`;
const ImpactAcrossTeams = () => {
  return (
    <>
      <Helmet>
        <title>AI for Marketing, Research, and Strategy Teams</title>
        <meta name="description" content="BrandAstra helps marketing, PR, branding, consumer research, product development, service delivery and corporate strategy teams with AI-driven insights, using AI agents to streamline workflows and accelerate decision-making across digital touchpoints." />
        <meta name="keywords" content="BrandAstra, social listening, AI insights" />
        <link rel="canonical" href="https://qa.brandastra.ai/#impact" />
      </Helmet>
      <Wrapper>
        <Title>Impact Across Teams</Title>
        <CardContainer>
          {impactDataArray?.map((data, index) => {
            return (
              <IndividualCard key={index}>
                <CardTitle>{data?.title}</CardTitle>
                <MapContainer>
                  {data?.options?.map((value, index) => {
                    return (
                      <OptionsContainer key={index}>
                        {LandingCheckBox} <OptionsText>{value}</OptionsText>
                      </OptionsContainer>
                    );
                  })}
                </MapContainer>
                <ImageContainer>{data?.image}</ImageContainer>
              </IndividualCard>
            );
          })}
        </CardContainer>
      </Wrapper>
    </>

  );
};
export default ImpactAcrossTeams;
